import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactModal from "react-modal";

function ConsultarServicios(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerServiciosPorSede/" +
        props.sedeId +
        "/" +
        props.complejidad,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <div className="text-center">
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Consultar Servicios
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Servicios de la sede de {props.complejidad} complejidad
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Descripcion</th>

                        <th>Comentarios</th>
                        <th>Sede</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.servicio}</td>
                            <td>{item.descripcion}</td>
                            <td>{item.comentarios}</td>
                            <td>{item.nombre}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default ConsultarServicios;
